<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { format as formatDate } from 'date-fns';

  import { SparkChart } from '@client/components/charts';
  import { Spinner } from '@client/components/spinner';

  import { AssetsService } from '@client/services/assets';

  import { secondsToHms } from '@common/utils/numbers';

  export let row = {};
  export let props = {};

  let loading = false;

  let chartData = { datasets: [] };

  const buildVideoSessionReport = (data) => {
    const activity = data.activity;

    if (!activity) {
      return;
    }

    const chartdata = [];

    activity.forEach((event) => {
      data.sessions = data.sessions || {};
      data.sessions[event.note.session + '-id'] = {
        selected: true,
        recipient: event.recipient,
        location: event.note.location,
        utcts: event.note.utcts,
        ...event.note
      };

      if (event.note.type === 'duration' && data.sessions[event.note.session + '-id'].selected) {
        if (event.note.end && event.note.end > event.note.start) {
          chartdata.push({
            session: formatDate(new Date(event.utcts), 'MMM d, yyyy h:mm:ss a'),
            low: event.note.start,
            high: event.note.end
          });
        }
      }
    });

    data.series = generateMetricDataset(chartdata);

    return data;
  };

  const styles = 'border-width: 2px; color: #0087ff; height: 16px; width: 16px;';

  const colors = {
    sent: '#43A0FC',
    viewed: '#D9BC61',
    downloaded: '#92E2C0'
  };

  const formatValue = (value) => secondsToHms(value);

  const generateMetricDataset = (series = []) => {
    const labels = series.map((item) => item.session);
    const lowData = series.map((item) => item.low);
    const highData = series.map((item) => item.high);

    return {
      labels,
      datasets: series?.length
        ? [
            {
              label: $format('label.SESSION_START'),
              data: lowData,
              borderColor: '#43A0FC',
              backgroundColor: '#43A0FC'
            },
            {
              label: $format('label.SESSION_END'),
              data: highData,
              borderColor: '#D9BC61',
              backgroundColor: '#D9BC61'
            }
          ]
        : []
    };
  };

  const update = async () => {
    loading = true;

    const id = row.rulename;

    if (!props.metricsCache[id]) {
      const response = await AssetsService.getVideoMetrics(row._id, row.vidid);
      const metrics = buildVideoSessionReport({ duration: row.duration, activity: response });
      props.metricsCache[id] = metrics.series;
      props.onUpdate(props.metricsCache);
    } else {
      chartData = { ...props.metricsCache[id] };
    }

    loading = false;
  };

  onMount(async () => await update());

  $: data = props.metricsCache[row.rulename] || chartData;
</script>

<div class="charts">
  <div class="chart">
    {#if loading}
      <Spinner show inline {styles} />
    {:else if data?.datasets.length}
      <SparkChart bind:data height="25px" {formatValue} />
    {:else}
      <p class="empty">No session data</p>
    {/if}
  </div>
</div>

<style lang="scss">
  .charts {
    align-items: center;
    display: grid;
    grid-template-columns: minmax(130px, 1fr);
    gap: 24px;

    .chart {
      height: 30px;
      max-width: 130px;
      position: relative;

      :global(.spinner) {
        justify-content: flex-start;
      }

      &:hover {
        z-index: 10;
      }

      p {
        color: var(--color-gray-600);
      }
    }
  }
</style>
